import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
// import IconButton from 'components/common/IconButton';
// import { accountInfo, billingInfo } from 'data/ecommerce/customerDetailsData';
import classNames from 'classnames';
// import createMarkup from 'helpers/createMarkup';
import PropTypes from 'prop-types';
import moment from 'moment';

const HospitalInfo = ({ hospital }) => {
  const format = value => {
    const inputPhoneNumber = value.replace(/\D/g, '');
    const limitedPhoneNumber = inputPhoneNumber.slice(0, 10);
    const formattedPhoneNumber =
      limitedPhoneNumber.length === 10
        ? limitedPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
        : limitedPhoneNumber;
    return formattedPhoneNumber;
  };

  return (
    <Card className="mb-3">
      <Card.Header>
        <Row className="align-items-center">
          <Col>
            <h5 className="mb-0">Details</h5>
          </Col>
          {/* <Col xs="auto">
            <IconButton
              iconClassName="fs-11 me-1"
              variant="falcon-default"
              size="sm"
              icon="pencil-alt"
            >
              Update details
            </IconButton>
          </Col> */}
        </Row>
      </Card.Header>
      <Card.Body className="bg-body-tertiary border-top">
        <Row>
          <Col lg xxl={5}>
            <h6 className="fw-semibold ls mb-3 text-uppercase">
              Account Information
            </h6>

            {/* {accountInfo.map(item => (
              <Row key={item.id}>
                <Col xs={5} sm={4}>
                  <p className="fw-semibold mb-1">{item.label}</p>
                </Col>
                <Col>
                  <p
                    className={classNames('mb-1', {
                      'fst-italic text-400': !item.active
                    })}
                  >
                    {item.email || item.phone ? (
                      <a
                        href={`${item.email && `mailto:`}
                        ${item.phone && `tel:`}`}
                      >
                        {item.value}
                      </a>
                    ) : item.important ? (
                      <b>{item.value}</b>
                    ) : (
                      item.value
                    )}
                  </p>
                </Col>
              </Row>
            ))} */}

            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-semibold mb-1">ID</p>
              </Col>
              <Col>
                <p className={classNames('mb-1')}>{hospital?.id}</p>
              </Col>
            </Row>
            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-semibold mb-1">Created</p>
              </Col>
              <Col>
                <p className={classNames('mb-1')}>
                  {moment(hospital?.createdAt).format('yyyy/mm/dd hh:mm a')}
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-semibold mb-1">Email</p>
              </Col>
              <Col>
                <p className={classNames('mb-1')}>
                  <a href={`mailto:${hospital?.email}`}>{hospital?.email}</a>
                </p>
              </Col>
            </Row>
          </Col>

          <Col lg xxl={{ span: 5, offset: 1 }} className="mt-4 mt-lg-0">
            <h6 className="fw-semibold ls mb-3 text-uppercase">
              Billing Information
            </h6>

            {/* {billingInfo.map(item => (
              <Row key={item.id}>
                <Col xs={5} sm={4}>
                  <p className="fw-semibold mb-1">{item.label}</p>
                </Col>
                <Col>
                  {item.label === 'Address' ? (
                    <p
                      className={classNames('mb-1', {
                        'fst-italic text-400': !item.active
                      })}
                      dangerouslySetInnerHTML={createMarkup(item.value)}
                    ></p>
                  ) : (
                    <p
                      className={classNames('mb-1', {
                        'fst-italic text-400': !item.active
                      })}
                    >
                      {item.email || item.phone ? (
                        <a
                          href={`${item.email && `mailto:`}
                      ${item.phone && `tel:`}`}
                        >
                          {item.value}
                        </a>
                      ) : item.important ? (
                        <b>{item.value}</b>
                      ) : (
                        item.value
                      )}
                    </p>
                  )}
                </Col>
              </Row>
            ))} */}
            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-semibold mb-1">Send email to</p>
              </Col>
              <Col>
                <p className={classNames('mb-1')}>
                  <a href={`mailto:${hospital?.email}`}>{hospital?.email}</a>
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-semibold mb-1">Address</p>
              </Col>
              <Col>
                <p className={classNames('mb-1')}>
                  <a
                    href={`https://maps.google.com/?q=${hospital?.fullAddress}`}
                    target={'_blank'}
                    rel="noreferrer"
                    className="text-dark"
                  >
                    {hospital?.fullAddress}
                  </a>
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-semibold mb-1">Phone Number</p>
              </Col>
              <Col>
                <p className={classNames('mb-1')}>
                  <a href={`tel:${hospital?.phoneOne}`}>
                    {format(hospital?.phoneOne)}
                  </a>
                </p>
              </Col>
            </Row>
            {hospital?.phoneTwo && (
              <Row>
                <Col xs={5} sm={4}>
                  <p className="fw-semibold mb-1">Secondary Number</p>
                </Col>
                <Col>
                  <p className={classNames('mb-1')}>
                    <a href={`tel:${hospital?.phoneTwo}`}>
                      {format(hospital?.phoneTwo)}
                    </a>
                  </p>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Card.Body>
      {/* <Card.Footer className="border-top text-end">
        <IconButton
          iconClassName="fs-11 me-1"
          variant="falcon-default"
          size="sm"
          icon="dollar-sign"
        >
          Refund
        </IconButton>
        <IconButton
          className="ms-2"
          iconClassName="fs-11 me-1"
          variant="falcon-default"
          size="sm"
          icon="check"
        >
          Save changes
        </IconButton>
      </Card.Footer> */}
    </Card>
  );
};

HospitalInfo.propTypes = {
  hospital: PropTypes.any
};

export default HospitalInfo;
